/**
 * File navigation.js.
 *
 * Handles toggling the navigation menu for small screens and enables TAB key
 * navigation support for dropdown menus.
 */
( function() {
    const siteNavigation = document.getElementById( 'site-navigation' );

    if ( ! siteNavigation ) return;

    const button = siteNavigation.getElementsByTagName( 'button' )[ 0 ];

    if ( 'undefined' === typeof button ) return;

    const menu = siteNavigation.getElementsByTagName( 'ul' )[ 0 ];

    if ( 'undefined' === typeof menu ) {
        button.style.display = 'none';
        return;
    }

    if ( ! menu.classList.contains( 'nav-menu' ) ) menu.classList.add( 'nav-menu' );

    button.addEventListener( 'click', function() {
        siteNavigation.classList.toggle( 'toggled' );
        
        const isExpanded = button.getAttribute( 'aria-expanded' ) === 'true';
        button.setAttribute( 'aria-expanded', !isExpanded );
    });

    document.addEventListener( 'click', function( event ) {
        const isClickInside = siteNavigation.contains( event.target );
        const isToggleButton = button.contains(event.target) || button === event.target;

        if ( ! isClickInside && ! isToggleButton ) {
            siteNavigation.classList.remove( 'toggled' );
            button.setAttribute( 'aria-expanded', 'false' );
        }
    });


    // Get all the link elements within the menu.
    const links = menu.getElementsByTagName( 'a' );

    // Get all the link elements with children within the menu.
    const linksWithChildren = menu.querySelectorAll( '.menu-item-has-children > a, .page_item_has_children > a' );

    // Toggle focus each time a menu link is focused or blurred.
    for ( const link of links ) {
        link.addEventListener( 'focus', toggleFocus, true );
        link.addEventListener( 'blur', toggleFocus, true );
    }

    // Toggle focus each time a menu link with children receives a touch event.
    for ( const link of linksWithChildren ) {
        link.addEventListener( 'touchstart', toggleFocus, { passive: false });
        link.addEventListener( 'click', toggleFocus, { passive: false });
    }

    /**
     * Sets or removes .focus class on an element.
     */
    function toggleFocus(event) {
        const self = this;
        let shouldPreventDefault = false;
    
        // If it's a focus or blur event, toggle focus on ancestors
        if (event.type === 'focus' || event.type === 'blur') {
            while (!self.classList.contains('nav-menu')) {
                if ('li' === self.tagName.toLowerCase()) {
                    self.classList.toggle('focus');
                }
                self = self.parentNode;
            }
        }
    
        // If it's a touchstart or click event, toggle focus on siblings
        if (event.type === 'touchstart' || event.type === 'click') {
            const menuItem = this.parentNode;
            for (const link of menuItem.parentNode.children) {
                if (menuItem !== link) {
                    link.classList.remove('focus');
                }
            }
            shouldPreventDefault = menuItem.classList.toggle('focus');
        }
    
        // Prevent default action and stop propagation conditionally
        if (shouldPreventDefault) {
            event.preventDefault();
            event.stopPropagation();
        }
    }
    
}() );
